import { useState, useEffect } from 'react';
import { getLang } from '@/locales';

export default function usePageLang() {
  const [lang, setLang] = useState(getLang());
  useEffect(() => {
    const handler = () => setLang(getLang());
    window.addEventListener('langChange', handler);
    return () => window.removeEventListener('langChange', handler);
  }, []);

  const pick = (enVal, zhVal) => {
    if (lang === 'zh' && zhVal) return zhVal;
    return enVal || '';
  };

  return { lang, pick };
}
